import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../hooks/useAuthContext';
import { AuthContext } from '../../../context/AuthContext';
import Loading from '../../components/Loading';


const ProtectedRoute = ({ children }) => {
  const { user, validateToken } = useAuthContext(AuthContext);
  const [isValidating, setIsValidating] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const validate = async () => {
      //process.env.NODE_ENV === "development" && console.log("user validation ,aecqlwuyegc", user)
      if (!user) {
        setIsValidating(false);
        return;
      }

      const valid = await validateToken();
      setIsValid(valid);
      setIsValidating(false);
    };

    validate();
  }, [user, validateToken]);

  if (isValidating) {
    return <Loading />;
  }

  if (!user || !isValid) {
    // Redirect them to the login page, but save the current location they were trying to go to
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user needs to change password and is not already on the change-password page,
  // redirect to the change-password page
  if (user?.changePassword && location?.pathname !== "/change-password") {
    return <Navigate to="/change-password" state={{ from: location }} replace />;
  }
  if (!user?.changePassword && location?.pathname === "/change-password") {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
